// src/components/NewsTicker.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import NewspaperRoundedIcon from "@mui/icons-material/NewspaperRounded";

/**
 * ReactJS version of the React Native NewsTicker.
 * نفس المنطق: تمرير لانهائي للأخبار مع مضاعفة القائمة.
 */

const newsItems = [
  "1CryptoX launches AI Trade with advanced risk management.",
  "Referral Program: invite friends and earn USDT rewards on sign-up and trading.",
  "24/7 live support with instant chat and ticket escalation.",
  "Security & Compliance: KYC/AML safeguards with real-time monitoring.",
];

export default function NewsTicker() {
  const theme = useTheme();
  const [restartKey, setRestartKey] = useState(0);

  // إعادة تشغيل الأنيميشن عند تغيّر القائمة أو الحجم
  useEffect(() => {
    setRestartKey((k) => k + 1);
  }, [newsItems]);

  // تكرار القائمة مرتين (مثل fullNewsList)
  const fullNewsList = useMemo(() => [...newsItems, ...newsItems], []);

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.background.paper,
        px: 1.5,
        py: 1,
        my: 2,
        boxShadow: theme.shadows[1],
        "@keyframes scrollTicker": {
          "0%": { transform: "translateX(100%)" },
          "100%": { transform: "translateX(-100%)" },
        },
      }}
    >
      <Box
        sx={{
          width: 42,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <NewspaperRoundedIcon sx={{ color: theme.palette.primary.main }} />
      </Box>

      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          key={restartKey}
          sx={{
            display: "inline-flex",
            whiteSpace: "nowrap",
            animation: "scrollTicker 60s linear infinite",
            gap: 4,
            alignItems: "center",
          }}
        >
          {fullNewsList.map((item, index) => (
            <Typography
              key={index}
              variant="body2"
              sx={{
                fontWeight: 500,
                letterSpacing: 0.2,
                color: theme.palette.text.primary,
              }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
